// A list of of errors we want Sentry to ignore
export const ignoreErrors = [
  // Think this can be ignored safely
  'ResizeObserver loop completed with undelivered notifications',
  // Load failures
  'Network request failed',
  'Failed to fetch',
  'NetworkError',
  'A network error occurred',
  'TypeError: Load failed',
  'Failed to fetch',
  'Load failed',
  'aborted by the user agent',
  'Cancel rendering route',
  'Failed to load script',
  // Unknown why but we don't have any code that accesses frames
  'Blocked a frame with origin',
  // Next.js weirdness
  'Invariant: attempted to hard navigate to the same URL',
  // Seems to be a React Fragments issue. https://stackoverflow.com/questions/54880669/react-domexception-failed-to-execute-removechild-on-node-the-node-to-be-re
  'The node to be removed is not a child of this node',
  'The object can not be found here.',
  "Failed to execute 'insertBefore' on 'Node'",
  // Ignore error from unsupported old browser that doesn't support Promise.allSettled
  'TypeError: Promise.allSettled is not a function',
  // Caused by Facebook/Instagram. https://developers.facebook.com/community/threads/320013549791141/
  "Can't find variable: _AutofillCallbackHandler",
];
